import { render } from "./Coupons.vue?vue&type=template&id=8ab3a7d6"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"
script.render = render

export default script